import React, { useState } from 'react'
import Select, { SingleValue } from 'react-select'
import useToggle from '../hooks/useToggle'
import { coverOptionsToArray } from '../plugins/utils/coverpageUtils'

interface Props {
    toggleCoverActive: (params: boolean) => void
    send: (msg: string, payload: string) => void
    coverOptions: any
    dataset: any
    mainSizing: {
        width: string
        height: string
        menuOverlayHeight: string
    }
}

export const CoverPage: React.FC<Props> = ({ toggleCoverActive, dataset, coverOptions, send, mainSizing}: Props) => {
    const [selectedOption, setSelectedOption] = useState('')
    const [selectAlert, toggleSelectAlert] = useToggle(false)
    
    const { width, menuOverlayHeight } = mainSizing
    const {
        cover_page_bg_color,
        cover_page_text_color,
        cover_page_dropdown_bg_color,
        cover_page_dropdown_text_color,
        header_bg_color,
        header_text_color,
    } = dataset

    const { title, text, buttonText, options, dropdownSubheader, redirectPlugin } = coverOptions

    const customStyles = {
        control: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: cover_page_dropdown_bg_color,
            color: cover_page_dropdown_text_color,
            borderRadius: state.isFocused ? '10px 10px 0px 0px' : '10px',
            border: state.isFocused ? 'none' : 'none',
            boxShadow: state.isFocused ? 'none' : 'none',
            cursor: 'pointer',
        }),
        singleValue: (provided: any, state: any) => ({
            ...provided,
            color: cover_page_dropdown_text_color,
        }),
        placeholder: (provided: any, state: any) => ({
            ...provided,
            color: cover_page_dropdown_text_color,
        }),
        menu: (provided: any, state: any) => ({
            ...provided,
            margin: '0px',
            backgroundColor: cover_page_dropdown_bg_color,
            color: cover_page_dropdown_text_color,
            cursor: 'pointer',
            maxHeight: '300px',
            overflowY: 'scroll',
            border: 'none',
            borderRadius: '0px 0px 10px 10px',
        }),
        option: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: cover_page_dropdown_bg_color,
            filter: state.isFocused && 'brightness(110%)',
            color: cover_page_text_color,
        }),
    }

    let dropdownOptions = coverOptionsToArray(options)

    const onSubmit = () => {
        if (selectedOption !== '') {
            toggleCoverActive(false)
            send(selectedOption, '/submitCoverpage')
        } else {
            toggleSelectAlert(true)
        }
    }

    return (
        <div
            className='coverPageHolder'
            style={{ 
                width, 
                height: `calc(${menuOverlayHeight} - 80px)`,
                color: cover_page_text_color 
            }}
        >
            {title && <h3 className='coverPageHeader'>{title}</h3>}
            {text && <div className='coverPageText'>{text}</div>}
            {dropdownSubheader && <div className='coverPageSubheader'>{dropdownSubheader}</div>}
            <Select
                className='coverPageDropdown'
                placeholder={'choose one:'}
                styles={customStyles}
                options={dropdownOptions}
                onChange={(newValue: SingleValue<any>) => {
                    newValue && setSelectedOption(newValue.label)
                }}
            />
            {selectAlert && <div className='coverPageText'>Please select an option before submitting</div>}
            <div className='coverPageButtonContainer'>
                <button
                    onClick={() => onSubmit()}
                    className='coverPageSubmitButton'
                    style={{ color: header_text_color, backgroundColor: header_bg_color }}
                >
                    {buttonText}
                </button>
            </div>
        </div>
    )
}
